export const ERROR_REASONS = {
  ACCOUNT_TERMINATED: 'user-account-terminated',
  EMAIL_IN_USE: 'email-in-use',
  EMAIL_UNVERIFIED: 'email-unverified',
  UNAUTHORIZED: 'unauthorized',
  ACCOUNT_LINK_REQUIRED: 'account-link-required',
} as const;

export type ErrorReasons = keyof typeof ERROR_REASONS;
